/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_Run_DetailInputs */

const cs_settings_automation_run_detail = /** @type {(inputs: Settings_Automation_Run_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Běh automatizace`)
};

const en_settings_automation_run_detail = /** @type {(inputs: Settings_Automation_Run_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation run`)
};

/**
* | output |
* | --- |
* | "Automation run" |
*
* @param {Settings_Automation_Run_DetailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_run_detail = /** @type {((inputs?: Settings_Automation_Run_DetailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_Run_DetailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_run_detail(inputs)
	return cs_settings_automation_run_detail(inputs)
});